import { Box, Button, Paper, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const send = (
    frameHeight,
    frameWidth,
    top,
    right,
    bottom,
    left,
    floating,
    redirectUrl
) => {
    window.parent.postMessage(
        {
            reservationIframeHeight: frameHeight,
            reservationIframeWidth: frameWidth,
            reservationIframePositionTop: top,
            reservationIframePositionRight: right,
            reservationIframePositionBottom: bottom,
            reservationIframePositionLeft: left,
            reservationIframePositionFloating: floating,
            redirectUrl: redirectUrl,
        },
        "*"
    );
};


const SuccessScreen = () => {
    const {basicLanguages}=useSelector((store)=>store?.feedback)
   const parentURL=localStorage.getItem('parentUrl')
   const{css}=useSelector((store)=> store?.widgetSettings)
   const feedbackCss = css?.find((item) => item?.cssTabFieldsGroupName === "Feedback")?.fields;
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: "100%", height: "100vh",backgroundColor:feedbackCss?.feedbackSuccessBGclr }}>
      
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                    <CheckCircleIcon sx={{ width: 150, height: 150, color: '#1A615E' }} />
                    <Typography 
                        sx={{ 
                            color: feedbackCss?.feedbackSuccessHeadingClr, 
                            fontWeight: 'semiBold', 
                            fontSize: { xs: '24px', sm: '30px', md: '36px' }, // Responsive font sizes
                            lineHeight: '2rem',
                            mt: 3,
                            mb: 1 
                        }}
                    >
                       {basicLanguages?.HeaderSuccess}
                    </Typography>
                    <Typography 
                        sx={{ 
                            color: feedbackCss?.FeedbackInfoClr, 
                            fontWeight: 'regular', 
                            fontSize: { xs: '10px', sm: '12px', md: '14px' }, // Responsive font sizes
                            textAlign: 'center' 
                        }}
                    >
                       {basicLanguages?.SuccessInfo}
                    </Typography>
                    <Box sx={{ mt: 4 }}>
                    <Button variant="contained" sx={{ backgroundColor: feedbackCss?.NextBtnBgClr }} size="large"
                    // onClick={() => send("0px", "0px", "", "0px", "0px", "", "fixed", "/")}
                     onClick={() => {
                        if (window.parent && window.parent !== window) {
                          send("0px", "0px", "", "0px", "0px", "", "fixed", "/")
                        } else {
                          window.location.href = parentURL;
                        }
                      }}
                     >
                           {basicLanguages?.BackToHome}
                        </Button>
                    </Box>
                </Box>
           
        </Box>
    );
}

export default SuccessScreen;

